<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Devices</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Devices</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'DeviceList' }">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>
                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Device MAC</strong> {{ value.Device_MAC }}</li>

                  <li><strong>Mac</strong> {{ value.AP_WI_mac }}</li>

                  <li><strong>Name</strong> {{ value.Name }}</li>

                  <li><strong>Status</strong> {{ value.status }}</li>

                  <li><strong>Blocked</strong> {{ value.blocked }}</li>

                  <li>
                    <strong>Last Updated</strong> {{ value.last_updated }}
                  </li>

                  <li><strong>Start Time</strong> {{ value.start_time }}</li>

                  <li><strong>End Time</strong> {{ value.end_time }}</li>

                  <li><strong>Days</strong> {{ value.days }}</li>

                  <li><strong>Start Date</strong> {{ value.start_date }}</li>

                  <li><strong>End date</strong> {{ value.end_date }}</li>

                  <li>
                    <strong>Time Profile</strong> {{ value.time_profile_no }}
                  </li>

                  <li><strong>Group Name</strong> {{ value.group_name }}</li>

                  <li>
                    <strong>Bandwidth Limit</strong> {{ value.bandwidth_limit }}
                  </li>

                  <li><strong>Priority</strong> {{ value.priority }}</li>

                  <li>
                    <strong>Connected SSID</strong> {{ value.connected_ssid }}
                  </li>

                  <li>
                    <strong>Connectivity Status</strong>
                    {{ value.connectivity_status }}
                  </li>

                  <li>
                    <strong>Last Connectivity</strong>
                    {{ value.last_connectivity }}
                  </li>

                  <li>
                    <strong>Mac Filter Enable</strong>
                    {{ value.mac_filter_enable }}
                  </li>

                  <li><strong>Wifi Signal</strong> {{ value.wifi_signal }}</li>

                  <li><strong>IP Address</strong> {{ value.ip_address }}</li>

                  <li><strong>Change Flag</strong> {{ value.change_flag }}</li>

                  <li>
                    <strong>Mac Filter Flag</strong> {{ value.mac_filter_flag }}
                  </li>

                  <li>
                    <strong>Last Change Time</strong>
                    {{ value.last_change_time }}
                  </li>

                  <li><strong>Acttype</strong> {{ value.acttype }}</li>

                  <li><strong>UserID</strong> {{ value.userid }}</li>

                  <li><strong>Gmt</strong> {{ value.gmt }}</li>

                  <li><strong>Devicetoken</strong> {{ value.devicetoken }}</li>

                  <li><strong>deviceid</strong> {{ value.deviceid }}</li>

                  <li>
                    <strong>Is Push Sent</strong> {{ value.is_push_sent }}
                  </li>

                  <li>
                    <strong>IP Change Time</strong> {{ value.ip_change_time }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from '@/services/api'
import axios from 'axios'
const fileDownload = require('js-file-download')
import { Notification } from 'element-ui'

export default {
  name: 'DeviceShow',
  metaInfo: {
    title: 'Devices | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/devices/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
